// Actions setters etc
export const USER_FETCH_PERMISSIONS_DATA = 'user/FETCH_PERMISSIONS_DATA';
export const USER_SET = 'user/SET';
